import React from 'react'
import Appbar from 'components/Appbar'
import { PageContent, ModalLayer } from '@ui'
import { Router, RouteComponentProps } from '@reach/router'
import Tableview from './Tableview'
import useAssets from './hooks/useAssets'
import AssetSearch from './AssetSearch'

export default function AssetManagement({ navigate }: RouteComponentProps) {
  const assets = useAssets()
  return (
    <>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Router primary={false} navigate={navigate}>
        <ModalLayer path="*" reload={assets.reload} />
      </Router>
      <Appbar title="Assets">
        <AssetSearch hook={assets} navigate={navigate} />
      </Appbar>
      <PageContent>
        <Tableview
          hook={assets}
          clearFilter={() => {
            assets.search('')
          }}
          navigate={navigate}
        />
      </PageContent>
    </>
  )
}
